export interface EmailAddressValidationModel {
  isEmailAddressValidated: boolean;
  isValidEmailAddress: boolean;
  emailAddressExists: boolean;
}
